import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let kejianrouter = new Router({
   mode: "history",
  routes: [
    {
      path: "/about",
      name: "about",
      component: () => import('@/views/leTianAbout.vue')
    },
    {
      path: "/detail",
      name: "detail",
      component: () => import('@/views/leTianProductDetail.vue')
    },
    {
      path: "/test",
      name: "test",
      component: () => import('@/views/testI18n.vue')
    },
    {
      path: "/manger",
      name: "manger",
      component: () => import('@/views/product/index.vue')
    },
    {
      path: "/login",
      name: "login_leTian",
      component: () => import('@/views/login.vue')
    },
    {
      path: "/",
      name: "home",
      component: () => import('@/views/leTianIndex.vue')
    },
    {
      path: "/product",
      name: "product",
      component: () => import('@/views/leTianProduct.vue')
    },
    {
      path: "/about",
      name: "about",
      component: () => import('@/views/leTianAbout.vue')
    },
    {
      path: "/news",
      name: "news",
      component: () => import('@/views/leTianNews.vue')
    },
    {
      path: "/service",
      name: "service",
      component: () => import('@/views/leTianService.vue')
    },
    {
      path: "/recruitment",
      name: "recruitment",
      component: () => import('@/views/leTianRecruitment.vue')
    },
    {
      path: "/brand",
      name: "brand",
      component: () => import('@/views/brand.vue')
    }
  ]
})

// 判断是否需要登录权限 以及是否登录
kejianrouter.beforeEach((to, from, next) => {
  // 判断是否需要登录权限
  if (to.matched.some(res => res.meta.requireAuth)) {
    // 判断是否登录
    if (sessionStorage.getItem('token')) {
      next()
    } else {
      // 没登录则跳转到登录界面
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }
})

export default kejianrouter